<template>
    <!-- We need to use the props prefix because for is a reserved word-->
    <div v-if="props.for" class="form-field">
        <slot name="label">
            <label :for="props.for" :class="customClass">
                <slot name="prepend"></slot>
                {{ label }}
            </label>
        </slot>
        <div :class="fieldClass">
            <slot></slot>
            <span v-if="error" class="tw-text-red-500 tw-text-xs" v-html="error"></span>
            <span v-if="success" class="tw-text-emerald-500 tw-text-xs" v-html="success"></span>
        </div>
    </div>
    <dl v-else class="form-field tw-mb-0">
        <slot name="label">
            <dt :class="customClass">
                <slot name="prepend"></slot>
                {{ label }}
            </dt>
        </slot>
        <dd class="tw-mb-0" :class="fieldClass">
            <slot></slot>
            <span v-if="error" class="tw-text-red-500 tw-text-xs" v-html="error"></span>
            <span v-if="success" class="tw-text-emerald-500 tw-text-xs" v-html="success"></span>
        </dd>
    </dl>
</template>
<script setup lang="ts">
import { provide } from 'vue';

const props = defineProps({
    label: {
        type: [String, null],
        required: false,
        default: null,
    },
    for: {
        type: String,
        required: false,
    },
    customClass: {
        type: [String, Object],
        required: false,
    },
    fieldClass: {
        type: String,
        required: false,
    },
    error: {
        type: [String, Boolean],
        default: '',
    },
    success: {
        type: [String, Boolean],
        default: '',
    },
});
provide('error', props.error);
provide('success', props.success);
</script>
<style lang="scss" scoped>
@use '@/assets/sass/eventbooks/variables' as variables;

.form-field {
    display: flex;
    flex-direction: column;

    & > label,
    & > dt {
        font-family: variables.$eventwise-font-body;
        margin-bottom: 0;
        font-size: 0.85em;
        font-weight: 400;
        color: #656d9a;
    }
}
</style>
